import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=2030c440&scoped=true"
import script from "./DeviceDetail.vue?vue&type=script&lang=js"
export * from "./DeviceDetail.vue?vue&type=script&lang=js"
import style0 from "./DeviceDetail.vue?vue&type=style&index=0&id=2030c440&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030c440",
  null
  
)

export default component.exports